import { Upload, FileText, Image, File, Trash2 } from "feather-icons-react";
import PropTypes from "prop-types";

const getFileIcon = (filename) => {
    const extension = filename.split(".").pop().toLowerCase();
    switch (extension) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
            return <Image className="w-6 h-6 text-yellow-500" />;
        case "pdf":
            return <FileText className="w-6 h-6 text-red-500" />;
        case "doc":
        case "docx":
            return <FileText className="w-6 h-6 text-blue-500" />;
        case "xls":
        case "xlsx":
            return <FileText className="w-6 h-6 text-green-500" />;
        default:
            return <File className="w-6 h-6 text-gray-500" />;
    }
};

const DocumentUploadComponent = ({ style, hidden, files, setFiles, setDeletedFileIds }) => {

    const handleFileUpload = (event) => {
        const uploadedFiles = Array.from(event.target.files).map((file) => ({
            file,
            name: file.name,
            url: URL.createObjectURL(file), // Creating an object URL for preview
            fileId: null, // New file has no ID yet
        }));
        setFiles([...files, ...uploadedFiles]);
    };

    const handleDelete = (index) => {
        const deletedFile = files[index];
        if (deletedFile.fileId) {
            // If it's an existing file, track its ID for deletion
            setDeletedFileIds((prevIds) => [...prevIds, deletedFile.fileId]);
        }
        // Remove from UI state
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    if (hidden) return null;

    return (
        <div className={`${style}`}>
            <div className="flex">
                <label className="inline-flex items-center cursor-pointer bg-green-500 text-blue px-4 py-2 rounded-md mb-4 hover:bg-green-600 transition">
                    <Upload className="w-5 h-5 mr-2" />
                    Upload Documents
                    <input
                        type="file"
                        multiple
                        className="hidden"
                        onChange={handleFileUpload}
                        aria-label="Upload documents"
                    />
                </label>
            </div>
            <div className="space-y-2">
                {files.map((file, index) => (
                    <div key={index} className="flex justify-between items-center border p-4 rounded-md shadow-md">
                        <div className="flex items-center gap-2">
                            <a
                                rel="noopener noreferrer"
                                href={file.url}
                                target="_blank"
                                className="flex items-center gap-2 text-blue-600 hover:underline"
                            >
                                {getFileIcon(file.name)}
                                <span>{file.name}</span>
                            </a>
                        </div>
                        <div className="flex items-center gap-4 pl-5">
                            <Trash2
                                className="w-5 h-5 text-red-500 cursor-pointer hover:text-red-700"
                                onClick={() => handleDelete(index)}
                                aria-label="Delete file"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

DocumentUploadComponent.propTypes = {
    style: PropTypes.string,
    hidden: PropTypes.bool,
    files: PropTypes.array.isRequired,
    setFiles: PropTypes.func.isRequired,
    setDeletedFileIds: PropTypes.func.isRequired, // ✅ Keep only this
};

export default DocumentUploadComponent;
